import { Card } from './Card';

export class Hand {
    cards: Card[] = [];
    index: number;

    constructor (i: number) {
        this.index = i;
    }

    clear () {
        this.cards = [];
    }

    draw (card: Card) {
        this.cards.push(card);
    }

    discard (index: number, keepPlayer: boolean = false): Card {
        const discarded = this.cards.splice(index, 1)[0];

        if (!keepPlayer) {
            discarded.player = undefined;
        }

        return discarded;
    }
}


// WEBPACK FOOTER //
// ./src/playing-cards/Hand.ts